export default __webpack_public_path__ + "static/media/loan-arrow.7cd08ba3.svg";